import { useTranslation } from 'react-i18next'
import { NavLink, Navigate, Outlet, useParams } from 'react-router'

import { ConnectionIcon } from 'app/common/presentation'
import { useConnections } from 'app/connections/application'
import { InstalledConnection, isInstalledConnection } from 'app/connections/types'

import { Chip } from 'components'

import { ConnectionProvider } from '../components/ConnectionContext'
import { mapToConnectionName, mapToUrl } from '../connectionUrlMapper'
import styles from './ManageConnection.module.scss'

const ManageConnection = () => {
  const { name = '' } = useParams()
  const { t } = useTranslation('connections')
  const { getConnection } = useConnections()
  const connectionName = mapToConnectionName(name)
  const selectedConnection = getConnection(connectionName)
  const connection: InstalledConnection | undefined =
    selectedConnection && isInstalledConnection(selectedConnection) ? selectedConnection : undefined

  const basePath = `/connections/${mapToUrl(connectionName)}/manage`

  if (!connection) {
    return <Navigate to={`/connections/${mapToUrl(connectionName)}`} replace />
  }

  return (
    <ConnectionProvider connection={connection}>
      <div className={styles.manage}>
        <header className={styles.header}>
          <div className={styles.identity}>
            <div className={styles.icon}>
              <ConnectionIcon connection={connection} />
            </div>
            <div>
              <div className={styles.title}>
                <h1>{t(`available.${connection.name}.displayName`)}</h1>
                <Chip color="green">{t('overview.browse.connected')}</Chip>
              </div>
              <div className={styles.types}>
                <span>{t('manage.source')}</span>
                <span>{t('manage.destination')}</span>
              </div>
            </div>
          </div>
        </header>
        <nav className={styles.tabs}>
          <NavLink
            className={({ isActive }) => (isActive ? styles.active : undefined)}
            end
            to={basePath}
          >
            {t('manage.tabs.overview')}
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? styles.active : undefined)}
            to={`${basePath}/settings`}
          >
            {t('manage.tabs.settings')}
          </NavLink>
        </nav>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </ConnectionProvider>
  )
}

export default ManageConnection
